import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactApexChart from 'react-apexcharts';
import './Chart.scss';
const Chart = ({ data, title, subtitle, type = 'bar', height = 350, width = '100%', colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4'], stacked = false, horizontal = false, showLegend = true, showDataLabels = false, className = '' }) => {
    // Early return if no data
    if (!data || !data.categories || !data.series || data.series.length === 0) {
        return (_jsxs("div", { className: `chart-container ${className}`, children: [title && _jsx("h3", { className: "chart-title", children: title }), subtitle && _jsx("p", { className: "chart-subtitle", children: subtitle }), _jsx("div", { className: "chart-no-data", children: _jsx("p", { children: "Carregando dados..." }) })] }));
    }
    const isPieOrDonut = type === 'pie' || type === 'donut';
    const options = {
        chart: {
            type: type,
            toolbar: {
                show: !isPieOrDonut,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true
                }
            },
            animations: {
                enabled: true,
                speed: 800,
                animateGradually: {
                    enabled: true,
                    delay: 150
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            }
        },
        title: {
            text: title,
            align: 'left',
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#1F2937'
            }
        },
        subtitle: {
            text: subtitle,
            align: 'left',
            style: {
                fontSize: '12px',
                color: '#6B7280'
            }
        },
        // Only include xaxis and yaxis for non-pie/donut charts
        ...(isPieOrDonut ? {} : {
            xaxis: {
                categories: data?.categories || [],
                labels: {
                    style: {
                        colors: '#6B7280',
                        fontSize: '12px'
                    }
                },
                axisBorder: {
                    color: '#E5E7EB'
                },
                axisTicks: {
                    color: '#E5E7EB'
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: '#6B7280',
                        fontSize: '12px'
                    },
                    formatter: function (value) {
                        if (value >= 1000) {
                            return (value / 1000).toFixed(1) + 'k';
                        }
                        return value.toString();
                    }
                }
            }
        }),
        colors: colors,
        plotOptions: {
            bar: {
                horizontal: horizontal,
                borderRadius: 4,
                dataLabels: {
                    position: 'top'
                }
            },
            // Specific options for pie/donut charts
            ...(isPieOrDonut ? {
                pie: {
                    donut: {
                        size: type === 'donut' ? '60%' : '0%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#1F2937'
                            },
                            value: {
                                show: true,
                                fontSize: '16px',
                                fontWeight: 700,
                                color: '#1F2937',
                                formatter: function (val) {
                                    return val.toString();
                                }
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                fontSize: '16px',
                                fontWeight: 700,
                                color: '#1F2937',
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toString();
                                }
                            }
                        }
                    }
                }
            } : {})
        },
        dataLabels: {
            enabled: showDataLabels || isPieOrDonut,
            style: {
                fontSize: '12px',
                colors: ['#1F2937']
            },
            // Specific dataLabels for pie/donut
            ...(isPieOrDonut ? {
                formatter: function (val, opts) {
                    return opts.w.globals.labels[opts.seriesIndex] + '\n' + val.toFixed(1) + '%';
                }
            } : {})
        },
        legend: {
            show: showLegend,
            position: isPieOrDonut ? 'bottom' : 'top',
            horizontalAlign: isPieOrDonut ? 'center' : 'right',
            fontSize: '12px',
            labels: {
                colors: '#6B7280'
            }
        },
        // Only include grid for non-pie/donut charts
        ...(isPieOrDonut ? {} : {
            grid: {
                borderColor: '#E5E7EB',
                strokeDashArray: 4
            }
        }),
        tooltip: {
            theme: 'light',
            y: {
                formatter: function (value) {
                    if (value >= 1000) {
                        return (value / 1000).toFixed(1) + 'k';
                    }
                    return value.toString();
                }
            }
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    chart: {
                        height: 250
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center'
                    }
                }
            }
        ]
    };
    // For pie/donut charts, we need to format the data differently
    const series = isPieOrDonut
        ? data.series[0]?.data || []
        : data.series.map(s => ({
            name: s.name,
            data: s.data
        }));
    // For pie/donut charts, we need to set labels
    if (isPieOrDonut) {
        options.labels = data.categories;
    }
    return (_jsx("div", { className: `chart-container ${className}`, children: _jsx(ReactApexChart, { options: options, series: series, type: type, height: height, width: width }) }));
};
export default Chart;
